import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import { FaPaperPlane} from 'react-icons/fa'
import Loading from '../images/loading.png'

  class Messages extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        messages: [],
        user_details: {},
        message: '',
        selected_chat: '',
        chat: [],
        clients: [],
        trainers: [],
        loading: true
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.FetchMessages = () => {
        const { cookies } = this.props;
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))

        axios.post(Backend_Url + 'getAllMessages', data)
        .then((res) => {
            let result = res.data
            if(result.length != 0){
              this.setState({messages: result})
            }
            this.setState({loading: false})
        }).catch((error) => {
            console.log(error)
        })
      }

      this.SendMessage = (e) => {  
        e.preventDefault()
        const { cookies } = this.props;

        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('receiver_id', this.state.selected_chat)
        data.append('message', this.state.message)

        axios.post(Backend_Url + 'sendMessage', data)
        .then((res) => {
            let result = res.data
            this.setState({message: ''})
            // alert('Message sent.')
        }).catch((error) => {
            console.log(error)
            alert('Something went wrong, please try again.')
        })
      }

      this.SwitchConversation = (chat_id) => {
        this.setState({selected_chat: chat_id})
      }

      this.CheckMessages = () => {
        var user_type = this.state.user_details.role
        var messages = this.state.messages
        var empty = true

        if(user_type == 'trainer'){
          if((messages.length != 0) || (this.state.clients.length != 0)){
            empty = false
          }
        }else{
          if((messages.length != 0) || (this.state.trainers.length != 0)){
            empty = false
          }
        }

        if(empty){
          return<div>
            <br/><br/>
            <h6>
              You have no messages.
            </h6>
          </div>
        }else{
          const {cookies} = this.props
          var user_id = ''
          if(Object.entries(this.state.user_details).length != 0){
            user_id = this.state.user_details._id.$oid
          }
          var user_type = this.state.user_details.role

          // Create Set (stores only unique values)
          var items = new Set();

          if(user_type == 'trainer'){
            this.state.clients.map((client, index) => {
              items.add(client._id.$oid)
            })
          }else{
            this.state.trainers.map((trainer, index) => {
              items.add(trainer._id.$oid)
            })
          }

          messages.map((item, index) => {
            var sender_id = item.sender_id
            var receiver_id = item.receiver_id

            if(sender_id == user_id){
              items.add(receiver_id);
            }else{
              items.add(sender_id);
            }
          })

          // Set to array
          var unique_ids = [...items]
          unique_ids = unique_ids.filter(item => item != user_id)

          var conversation_list = unique_ids.map((chat_id, index) => {
            try{
              var chat_title = messages.find(x => x.sender_id == chat_id).sender_name
            }catch(err){
              try{
                var chat_title = messages.find(x => x.receiver_id == chat_id).receiver_name
              }catch(ex){
                try{
                  var chat_title = this.state.clients.find(x => x._id.$oid == chat_id).firstname
                }catch{
                  var chat_title = this.state.trainers.find(x => x._id.$oid == chat_id).firstname
                }
              }
            }
            

            return<Row style={{margin: '5px', borderBottom: '1px solid #dce1e5'}}>
              <Button onClick={() => this.SwitchConversation(chat_id)} style={{margin: '5px', border: 'none', color: 'inherit', backgroundColor: 'inherit', width: '100%', textAlign: 'left', boxShadow: ''}}>
                {chat_title}
              </Button>
            </Row>
          })

          return <div>
            {conversation_list}
          </div>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
      const { cookies } = this.props;
      var data = new FormData()
      data.append('user_access_token', cookies.get('token'))

      this.FetchMessages()
      this.interval = setInterval(() => this.FetchMessages(), 1000)

      axios.get(Backend_Url + 'getUserDetailsByAccessToken/' + cookies.get('token'))
      .then(res => {
        this.setState({
          user_details: res.data
        });
      })
      .catch((error) => {
        console.log(error);
      });

      axios.post(Backend_Url + 'allClients', data)
      .then((res) => {
          let result = res.data
            this.setState({clients: result})
      }).catch((error) => {
          console.log(error)
      })

      axios.post(Backend_Url + 'getTrainers', data)
      .then((res) => {
          let result = res.data
          this.setState({trainers: result})
      }).catch((error) => {
          console.log(error)
      })
    }




    render() {
      if(this.state.loading == true){
        return (
          <Row>
              <Helmet>
                <title>CLIENTS - ONFIT</title>
                {/* <meta name="description" content="" /> */}
              </Helmet>
              <div style={{minHeight: '900px', backgroundColor: '#ffffff', opacity: 0.9}}>
                <br/><br/>
                <img src={Loading} style={{width: '30%'}}/>
                <br/><br/><br/>
              </div>
          </Row>
        );
      }

      var user_id = ''
      if(Object.entries(this.state.user_details).length != 0){
        user_id = this.state.user_details._id.$oid
      }
      var conversation = []
      this.state.messages.map((message, index) => {
        if(message.receiver_id == this.state.selected_chat){
          conversation.push(message)
        }
        if(message.sender_id == this.state.selected_chat){
          conversation.push(message)
        }
      })

      var all_messages = conversation
      all_messages.sort((a, b) => a.date_sent.localeCompare(b.date_sent));
      var exchanged_messages = all_messages.map((message, index) => {
        var chat_div = document.getElementById('chat');
        chat_div.scrollTop = chat_div.scrollHeight;
        if(user_id==message.sender_id){
          return<Row style={{marginBottom: '10px'}}>
            <Col style={{borderRadius: '20px', textAlign: 'left', marginLeft: '90px', backgroundColor: '#FFFFFF', marginBottom: '10px'}}>
              <h6 style={{textAlign: 'center', color: '#302142'}}>
                You
              </h6>
              {message.message}
              <br/>
              <h6 style={{textAlign: 'right', color: '#302142'}}>
                {message.date_sent.slice(0,-10)}
              </h6>
            </Col>
          </Row>
        }else{
          return<Row style={{marginBottom: '10px'}}>
            <Col style={{borderRadius: '20px', textAlign: 'left', marginRight: '90px', backgroundColor: '#FFFFFF', marginBottom: '10px'}}>
              <h6 style={{textAlign: 'center', color: '#302142'}}>
                {message.sender_name}
              </h6>
              {message.message}
              <br/>
              <h6 style={{textAlign: 'right', color: '#302142'}}>
                {message.date_sent.slice(0,-10)}
              </h6>
            </Col>
          </Row>
        }
      })

      return (
        <Row>
            <Helmet>
              <title>TRAINER MESSAGES- ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Messages
              </h4>
              <br/><br/>
              <Container>
                <Row>
                  <Col style={{height: '350px', overflowY: 'scroll'}} sm='4'>
                  <this.CheckMessages/>
                  </Col>
                  <Col>
                    <Form onSubmit={this.SendMessage} style={{boxShadow: '0 1px 4px 0 #302142', borderRadius: '20px', backgroundColor: '#dfd7ea'}}>
                      <Row>
                        <Col id='chat' style={{height: '320px', overflowY: 'scroll'}}>
                          <Container>
                            {exchanged_messages}
                          </Container>
                        </Col>
                      </Row>
                      <Row style={{backgroundColor: '#FFFFFF', borderBottomRightRadius: '20px', borderBottomLeftRadius: '20px', paddingBottom: '15px'}}>
                        <Col>
                          <Input style={{border: 'none', backgroundColor: 'inherit'}} placeholder="Type in your message here" type="text" name="message" id="message" 
                            value={this.state.message} onChange={this.HandleChange} />                  
                        </Col>
                        <Col xs='1' onClick={this.SendMessage} type='submit' style={{paddingTop: '5px', textAlign: 'left'}}>
                          <FaPaperPlane/>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Messages);